<template>
  <div>
    <p>
      <strong>{{ $t("contract.other_absence.headline") }}</strong>
    </p>
    <p>{{ $t('contract.other_absence.paragraphs.first') }}</p>
    <p v-show="otherAbsence.extendedRights">
      <label class="user-output">{{ otherAbsence.extendedRightsDescription }}</label>
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    otherAbsence() {
      return this.$store.state.contract.otherAbsence;
    }
  }
};
</script>
